export enum ScriptNameEnum {
  GOOGLE_MAPS = 'google-maps',
  GOOGLE_MAPS_CLUSTERER = 'google-maps-clusterer',
  HUBSPOT_SHELL = 'hubspot-shell',
  HUBSPOT_WEBSITE = 'hubspot-website',
  HUBSPOT_FORMS_EMBED = 'hubspot-forms-embed',
}
